export const LINK_DATA_WIZARD_TEXT = {
  step: 'link-data',
  title: 'Link Data',
  description:
    'Add the data that you want to be passed to your app via this QR Code. This data is also used to configure QR Code functions like routing, attribution windows, etc. All keys and values are case-sensitive. ',
  linkText: 'Learn More.',
  link: 'https://help.branch.io/using-branch/docs/creating-a-deep-link#configure-deep-links',
} as const;
